var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"language":_vm.language}})
}
var staticRenderFns = []

export { render, staticRenderFns }